import { defineStore } from "pinia";
import router from "@/route";
import type { LoginRes, UserType } from "@/types/UserType";
import type { AuthStatusEnum, UserRoleEnum } from "@/types/enums";
import type { UserWechatType } from "@/types/UserWechatType";

export const useUserStore = defineStore("user", {
  state: () => ({
    role: null as UserRoleEnum | null,
    token: null as string | null,
    username: null as string | null,
    phone: null as string | null,
    id: null as number | null,
    auth_status: "waitInfo" as AuthStatusEnum,
    mchid: null as number | null,
    childUserIndex: -1,
    childUserList: [] as UserType[],
    loadingChildUserList: false,
    priv_key: "",
    platform_pub_key: "",
    loginUser: {} as UserType,
    wechat_list: [] as UserWechatType[],
  }),
  actions: {
    // 登录成功，设置数据
    loginSuccess(loginRes: LoginRes) {
      console.log("登录成功: ", loginRes);
      this.role = loginRes.role;
      this.token = loginRes.token;
      this.id = loginRes.id;
      this.mchid = loginRes.mchid;
      this.auth_status = loginRes.auth_status;
      this.username = loginRes.username;
      this.phone = loginRes.phone;
      this.priv_key = loginRes.priv_key;
      this.platform_pub_key = loginRes.platform_pub_key;
      this.wechat_list = loginRes.user_wechat_list;
      if (loginRes.child_user_list) {
        this.childUserList = loginRes.child_user_list;
        this.childUserIndex = this.childUserList.length > 0 ? 0 : -1;
      }
    },
    // 登出
    logout() {
      router.push("/login");
      this.role = null;
      this.token = null;
      this.childUserList = [];
      this.childUserIndex = -1;
    },
    // 检验是否登录
    isLogin(): boolean {
      return this.token != null;
    },
    changeChildUser(u: UserType) {
      if (this.childUserList.length > 0 && this.childUserIndex >= 0) {
        this.childUserList[this.childUserIndex] = u;
      }
    },
  },
  getters: {
    childUser: (state): UserType | null => {
      return state.childUserList[state.childUserIndex];
    },
  },
  persist: true,
});
